import { Link, useNavigate } from "react-router-dom";

const ControleBloc = () => {
  const navigate = useNavigate();
  const scrollToFormules = () => {
    const formulesSection = document.getElementById("formules-section");
    if (formulesSection) {
      formulesSection.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="relative-controle imageRight">
      <div className="container spaceBloc">
        <div className="row">
          <div className="col-md-6 ">
            <div className="mt-32">
              <h1 className="grey500">
                Libérez-vous du temps et{" "}
                <span className="bold600">gardez le contrôle</span> de votre
                activité !
              </h1>
              <p className="body grey66 mt-16">
                Twyny est la plateforme de réservation en libre-service qui vous
                simplifie la vie. Vos clients paient à l’avance en ligne, et
                vous êtes rémunéré dès la prestation effectuée.
              </p>
              <div className="bloc-cta mt-40">
                <button
                  className=" twyny-cta-primary mr-8"
                  onClick={() => navigate("/registerPrestataire")}
                >
                  Découvrir gratuitement
                </button>

                <button
                  className="mt-xs-8 twyny-cta-secondary"
                  onClick={scrollToFormules}
                >
                  Voir les formules
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ControleBloc;
